import styles from './newsblock.css'

type NewsItemProps = {
  heading: string
  date: string
  url: string
}

const NewsItem = ({ heading, date, url }: NewsItemProps): JSX.Element => (
  <a href={url} target="_blank" rel="noopener noreferrer">
    <h3 className={styles.heading}>{heading}</h3>
    <span className={styles.date}>{date}</span>
  </a>
)

type NewsBlockprops = {
  value: {
    heading: string
    news: Array<NewsItemProps>
  }
}

const NewsBlock = ({ value: { heading, news } }: NewsBlockprops) => (
  <div className={styles.wrapper}>
    <h2 className={styles.title}>{heading}</h2>
    <ul>
      {news.map((newsitem, i) => (
        <li key={String(i)}>
          <NewsItem {...newsitem} />
        </li>
      ))}
    </ul>
  </div>
)

export default NewsBlock
